/********************************************************
 *                                                      *
 * ----------------- SEGMENT TRACKER ------------------ *
 *                                                      *
 ********************************************************/

import { onRouteUpdate } from './types';
import setEventListeners from './EventListeners';
import { DATA_NAMES } from './constants';
import { getStandardProperties } from './utils';
import { store } from 'src/state/store';

// --- Check for Analytics to Init //
export default function initSegmentTraker(location: onRouteUpdate) {
    page(location);
    setEventListeners();
    initObserver();
}

// --- Observer Init //
function initObserver(): void {
    try {
        const targetNode = document.getElementById('gatsby-focus-wrapper');
        const config = { childList: true, subtree: true };
        let lastMutationElement: HTMLElement | undefined;
        const callback = function (mutationsList: MutationRecord[], _observer: object) {
            for (const mutation of mutationsList) {
                if (mutation?.target instanceof HTMLElement) {
                    let mutationTagName = mutation.target.tagName;
                    if (
                        mutationTagName === 'VIDEO' ||
                        mutationTagName === 'A' ||
                        mutationTagName === 'FORM'
                    ) {
                        if (lastMutationElement !== mutation.target) {
                            setEventListeners();
                            lastMutationElement = mutation.target;
                        }
                    }
                }
            }
        };
        const observer = new MutationObserver(callback);
        observer.observe(targetNode, config);
    } catch (err) {
        throw new Error(err);
    }
}

export function identify(userId?: string, traits?: { [index: string]: any }): void {
    if (!userId) {
        const state = store.getState();
        const account = state.account?.getAllAttrs?.data ?? null;
        if (account) {
            const { user, email } = account;
            window?.analytics?.identify(user.object.email, {
                email: user.object.email,
                userId: user.user_id,
                createdAt: user.created_at,
                firstName: user.object.first_name ?? undefined,
                lastName: user.object.last_name ?? undefined,
                phone: user.object.phone ?? undefined,
                marketingOptIn: !email.object.opt_out ?? undefined, // inverse: we want optIn not optOut
            });
        }
    } else {
        window?.analytics?.identify(userId, traits);
    }
}

export function track(
    eventName: string,
    properties: { [index: string]: any },
    callBack?: () => void
): void {
    window?.analytics?.track(
        eventName,
        {
            ...getStandardProperties(),
            ...properties,
        },
        callBack
    );
}

function page({ location: { pathname } }: onRouteUpdate): void {
    const pageViewEvent = DATA_NAMES.PAGE.includes(
        pathname.slice(-1) === '/' ? pathname.slice(0, -1) : pathname
    );
    if (pageViewEvent) {
        setTimeout(() => window.analytics.page(), 350);
    }
}
